<template>
  <DataTable :value='storeExpenses.rows' responsiveLayout='scroll' class="p-datatable-sm mt-4">
    <template #empty>
      No hay datos para mostrar
    </template>
    <Column field='date' header='Fecha'></Column>
    <Column field='concept' header='Concepto'></Column>
    <Column field='applicant' header='Solicitante'></Column>
    <Column field='amount' header='Valor'>
      <template #body="{data}">
        {{ $h.formatCurrency(parseFloat(data.amount), 2) }}
      </template>
    </Column>
    <Column field='acciones' header='Acciones'>
      <template #body="slotProps">
        <router-link :to="{ name:'pharmasan.contabilidad.caja-menor.ver-caja-menor.egresos.legalizar', params: {id:slotProps.data.id} }">
          <button
            type='button'
            class='p-button-rounded p-button-plain p-mr-3'
          >
            <font-awesome-icon class="text-lg text-blue-700" icon="clipboard-list"/>
          </button>
        </router-link>

        <router-link :to="{ name:'pharmasan.contabilidad.caja-menor.ver-caja-menor.egresos.editar', params: {id:slotProps.data.id} }">
          <button
            type='button'
            class='p-button-rounded p-button-plain p-mr-3'
          >
            <font-awesome-icon class="text-lg text-blue-700" icon="pen"/>
          </button>
        </router-link>

        <button
          v-on:click='deleteExpenseModal(slotProps.data.id)'
          type='button'
          class='p-button-rounded p-button-plain p-mr-3'
        >
          <font-awesome-icon class="text-lg text-blue-700" icon="trash-alt"/>
        </button>
      </template>
    </Column>
  </DataTable>
  <Paginator v-model:first="paginator.first" :rows="paginator.rows" :totalRecords="storeExpenses.count" @page="onPage($event)"></Paginator>
</template>

<script>
// import { ref } from 'vue'
import { computed, onMounted, ref } from 'vue'
import { useStore } from 'vuex'
import useExpense from '../../../hooks/useExpense'
// import { useRoute } from 'vue-router'

export default {
  name: 'homeTabsIngresosTable',
  setup () {
    const store = useStore()
    const storeExpenses = computed(() => store.getters['storePettyCash/getExpenses'])
    const storeDate = computed(() => store.getters['storePettyCash/getStoreDate'])
    const { deleteExpense, getExpenses } = useExpense()
    const paginator = ref({
      rows: 10,
      first: 0
    })

    const getExpensesSearch = async (filter) => {
      try {
        await getExpenses(filter)
      } catch (error) {
        console.error('Error al buscar ingreso', error)
      }
    }

    const deleteExpenseModal = async (id) => {
      await deleteExpense(id)
      await getExpensesSearch({ date: storeDate.value, query: { limit: paginator.value.rows, offset: 0 } })
    }

    const onPage = async (event) => {
      await getExpensesSearch({ date: storeDate.value, query: { limit: paginator.value.rows, offset: event.first } })
    }

    onMounted(async () => {
    })

    return {
      storeExpenses,
      paginator,
      deleteExpenseModal,
      onPage
    }
  }
}
</script>

<style scoped>

</style>
